
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternStbdColourOff as ObiLightLanternStbdColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-stbd-colour-off.js';
 
 
 

 
 export const ObiLightLanternStbdColourOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-stbd-colour-off',
   elementClass: ObiLightLanternStbdColourOffElement,
   events: {
     
   }
  });
 
 